



































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';

import PrineButton from '@/components/prine/PrineButton.vue';
import type { XLesson } from '@/models/xlesson';
import type { XSubProcess } from '@/models/xsubprocess';
import type { XProcess } from '@/models/xprocess';
import type { XWorksheet } from '@/models/xworksheet';
import { xWorksheetWebservice } from '@/webservices/xworksheet';
import { xSubProcessWebservice } from '@/webservices/xsubprocess';
import { xProcessWebservice } from '@/webservices/xprocess';
import LessonsList from '@/components/knowledge/lessons/LessonsList.vue';
import UpdateFilter from '@/components/worksheets/UpdateFilter.vue';
import { extractTagsFrom } from '@/helpers/extractTags';
import { LessonsFilter } from '@/helpers/types/LessonsFilter';
import { filterLessonContainer, filterLessons } from '@/helpers/filter/lessons/lessonsFilter';
import { allInLessonContainersSelected } from '@/helpers/filter/lessons/allInLessonContainersSelected';
import { deselectAll, selectAll } from '@/helpers/filter/lessons/selectAll';

@Component({
    name: 'CreateWorksheetX',
    methods: { extractTagsFrom },
    components: {
        UpdateFilter,
        PrineButton,
        LessonsList,
    },
})
export default class CreateWorksheetX extends Vue {
    private filters: LessonsFilter = {
        tags: [],
    };
    private checkedLessons = new Array<XLesson>();
    private xSubProcesses = new Array<XSubProcess>();
    private filteredXSubProcesses = new Array<XSubProcess>();
    private selectedXProcess: XProcess = {} as XProcess;

    private option: {
        filterByColumn: boolean;
        filterable: boolean;
    };
    private worksheet: XWorksheet = {} as XWorksheet;
    private isLoading: boolean = false;

    @Getter('project/selectedProject') private selectedProject: Project;
    private mounted() {
        if (this.$route.query.hasOwnProperty('phaseId')) {
            this.loadSelectedPhase(this.$route.query.phaseId);
        } else {
            this.goBack();
        }
    }

    @Watch('filters', { deep: true })
    private filterLessons() {
        this.filteredXSubProcesses = filterLessonContainer(
            JSON.parse(JSON.stringify(this.xSubProcesses)) as XSubProcess[],
            this.filters
        );
    }

    get allSelected() {
        return allInLessonContainersSelected(this.filteredXSubProcesses, this.checkedLessons);
    }

    private goBack() {
        this.$router.go(-1);
    }

    private loadSelectedPhase(phaseId) {
        xProcessWebservice.getById(phaseId).then((response) => {
            this.selectedXProcess = response.data;
            this.loadSubPhasesWithLessons();
        });
    }

    private loadSubPhasesWithLessons() {
        xSubProcessWebservice.load(this.selectedXProcess.id, ApprovalState.APPROVED).then((response) => {
            this.xSubProcesses = response.data;
            this.filterLessons();
            this.preselectMandatoryLessons();
        });
    }

    private preselectMandatoryLessons() {
        this.xSubProcesses.forEach((subProcess) => {
            this.selectLessonsIfMandatory(subProcess.lessons);
        });
    }

    private selectLessonsIfMandatory(lessons: XLesson[]) {
        lessons.forEach((lesson: XLesson) => {
            if (lesson.mandatory) {
                this.checkedLessons.push(lesson);
            }
            if (lesson.sub_lessons && lesson.sub_lessons.length > 0) {
                this.selectLessonsIfMandatory(lesson.sub_lessons);
            }
        });
    }

    private selectAllClick() {
        if (this.allSelected) {
            this.checkedLessons = deselectAll(this.filteredXSubProcesses, this.checkedLessons);
        } else {
            this.checkedLessons = selectAll(this.filteredXSubProcesses, this.checkedLessons);
        }
    }

    private createWorksheet() {
        this.worksheet.x_process = this.selectedXProcess;
        this.worksheet.project = this.selectedProject;
        this.isLoading = true;

        xWorksheetWebservice
            .store(this.worksheet, this.checkedLessons)
            .then((response) => {
                this.worksheet.id = response.data;

                this.$router.push({
                    name: 'WorksheetView',
                    query: {
                        id: this.worksheet.id.toString(),
                        type: 'x',
                    },
                });
            })
            .catch((error) => {
                console.log(error);
                this.isLoading = false;
            });
    }
}
